import React from "react";
import { useLocation } from "react-router-dom";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewJoinedGuestListPage from "../../components/JoinedGuestList/ViewJoinedGuestListPage";

const ViewScannedGuest = () => {
  const location = useLocation();
  const guestListId = location.state?.guestListId;

  return (
    <>
      <MasterLayout>
        {guestListId ? (
          <Breadcrumb
            title2="Guest List"
            link2="/guestList"
            title3="View Guest List"
            link3={`/guestList/view-guestList/${guestListId}`}
            title="Scan Guest List Detail"
          />
        ) : (
          <Breadcrumb
            title2="Scanned Guest List"
            link2="/scannedGuest"
            title="View Scanned Guest"
          />
        )}
        <ViewJoinedGuestListPage />
      </MasterLayout>
    </>
  );
};

export default ViewScannedGuest;
